import { z } from "zod";
import { DmaCalculationState } from "../dma-calculation-state";
export const dmaWaitingCalculationStatusDtoSchema = z.object({
    state: z.literal(DmaCalculationState.Waiting),
    jobSubmittedAt: z.string().datetime({ offset: true }),
    numberInQueue: z.number().int(),
    waitTimeEstimate: z.number(),
});
